module.exports = __webpack_public_path__ + "assets/girl_2x.7398cd5dd282ca384d342cadc1937f706bfaae4278760530a7b7d1a7693a6880.png";